import { render, staticRenderFns } from "./ExtendedTables.vue?vue&type=template&id=0c2d231b"
import script from "./ExtendedTables.vue?vue&type=script&lang=js"
export * from "./ExtendedTables.vue?vue&type=script&lang=js"
import style0 from "./ExtendedTables.vue?vue&type=style&index=0&id=0c2d231b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports